import type { TextBlock } from '../../../../interfaces/textEditor.interface';

export const CaseParagraph = (props: {
  index: number;
  block: TextBlock;
  onChange: (e: any) => void;
  onPaste: (e: any) => void;
}) => {
  const { index, block, onChange, onPaste } = props;
  return (
    <textarea
      className="Input__Area__Textarea w-full p-2 border rounded"
      id={`blocks.${index}.data.paragraph`}
      name={`blocks.${index}.data.paragraph`}
      placeholder={'Enter or paste text'}
      value={props.block.data?.paragraph || ''}
      onChange={props.onChange}
      onPaste={props.onPaste}
    />
  );
};
